import { render, staticRenderFns } from "./CookieConsentBanner.vue?vue&type=template&id=165bb985&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentBanner.vue?vue&type=style&index=0&id=165bb985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165bb985",
  null
  
)

export default component.exports